<div class="p-grid">
    <div class="p-col-12">
        <app-filter [filterByInput]="cols" [filterByInputValue]="filterByInputValue"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
            [showChannelFilter]="showChannelFilter" [channelList]="channelList" [selectedChannel]="selectedChannel"
            (onChangeChannel)="onChangeChannel($event)" [showWarehouseLocationFilter]="showWarehouseLocationFilter"
            [warehouseLocationList]="warehouseLocationList" [selectedWarehouseLocation]="selectedWarehouseLocation"
            (onWarehouseLocation)="onChangeWarehouseLocation($event)"
            (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
            (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)"
            (onChangeRange)="onChangeRange(selectedWindow, $event)" 
            [apiName]="apiName">
        </app-filter>
    </div>
    <div class="p-col-12">
        <div class="card">
            <div class="main-content">
                <!-- Inventory -->
                <div *ngIf="selectedWindow == ReportsInventoryNames.profitability
                            || selectedWindow == ReportsInventoryNames.inventoryopeninvoice
                            || selectedWindow == ReportsInventoryNames.inventoryallinvoice
                            || selectedWindow == ReportsInventoryNames.shipping
                            || selectedWindow == ReportsInventoryNames.openSalesOrders
                            || selectedWindow == ReportsInventoryNames.backSalesOrders
                            || selectedWindow == ReportsInventoryNames.salesOrderCommited">
                    <app-table [reportDatas]="reportDatas" [reportType]="'simpleTB'" [reportName]="reportName"
                        [reportDate]="reportDate" [selectedWindow]="selectedWindow" [cols]="cols"
                        [showInActive]="showInActive" (onShowInActiveClick)="onShowInActiveClick($event)">
                    </app-table>
                </div>
                <!-- group table -->
                <!-- <div *ngIf="selectedWindow == ReportsInventoryNames.invoiceByCustomer">
                    <app-table [reportDatas]="reportDatas" [reportType]="'groupTB'" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [cols] = "cols" [showInActive]="showInActive"
                        (onShowInActiveClick)="onShowInActiveClick($event)"
                        [showChannelFilter]="showChannelFilter" [reportTotalRow] = "reportTotalRow">
                    </app-table>
                </div> -->
                <!-- clickable table -->
                <div *ngIf="selectedWindow == ReportsInventoryNames.picktimebypicker
                            || selectedWindow == ReportsInventoryNames.picktimebylocation
                            || selectedWindow == ReportsInventoryNames.packtimebypacker
                            || selectedWindow == ReportsInventoryNames.packtimebylocation">
                    <app-table [reportType]="'clickableTB'" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [reportDatas]="reportDatas" [cols]="cols"
                        [reportRowDetails]="reportRowDetails" [detailsCols]="detailsCols" [detailsType]="'group'"
                        [detailsHeader]="detailsHeader" [detailsHeaderTitle]="detailsHeaderTitle"
                        [detailsGroupTypeColName]="detailsGroupTypeColName" (onTableRowClick)="onTableRowClick($event)"
                        (onTableRowDetailsExportClick)="onTableRowDetailsExportClick($event)"></app-table>
                </div>
                <div *ngIf="selectedWindow == ReportsInventoryNames.accountsReceivable
                            || selectedWindow == ReportsInventoryNames.accountsPayable">
                    <app-table [reportType]="'clickableTB'" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [reportDatas]="reportDatas"
                        [reportRowDetails]="reportRowDetails" [cols]="cols" [detailsCols]="detailsCols"
                        [detailsType]="'group'" [detailsHeader]="detailsHeader"
                        [detailsHeaderTitle]="detailsHeaderTitle" [detailsGroupTypeColName]="detailsGroupTypeColName"
                        (onTableRowClick)="onTableRowClick($event)"
                        (onTableRowDetailsExportClick)="onTableRowDetailsExportClick($event)"
                        [reportTotalRow]="reportTotalRow">
                    </app-table>
                </div>
                <div *ngIf="selectedWindow ==  ReportsInventoryNames.inventorySnapshot">
                    <app-table [reportType]="'groupTBFData'" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [reportDatas]="reportDatas" [cols]="cols"
                        [isActive]="isActive" [groupTypeColName]="groupTypeColName"
                        (onShowInActiveClick)="onShowInActiveClick($event)">
                    </app-table>
                </div>
                <div *ngIf="selectedWindow == ReportsInventoryNames.profitByRep
                            || selectedWindow == ReportsInventoryNames.profitByCustomer
                            || selectedWindow == ReportsInventoryNames.invoiceByRep
                            || selectedWindow == ReportsInventoryNames.invoiceByCustomer
                            || selectedWindow == ReportsInventoryNames.inventoryValuationDetail">
                    <app-table [reportType]="'groupTSBFData'" [reportTotalRow]="reportTotalRow"
                        [reportName]="reportName" [selectedWindow]="selectedWindow" [reportDatas]="reportDatas"
                        [cols]="cols" [isActive]="isActive" [groupTypeColName]="groupTypeColName"
                        (onShowInActiveClick)="onShowInActiveClick($event)">
                    </app-table>
                </div>
                <div *ngIf="selectedWindow == ReportsInventoryNames.inventoryAging">
                    <app-table [reportType]="'clickableTB'" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [reportDatas]="reportDatas"
                        [reportRowDetails]="reportRowDetails" [cols]="cols" [detailsCols]="detailsCols"
                        [detailsType]="'group'" [detailsHeader]="detailsHeader"
                        [detailsHeaderTitle]="detailsHeaderTitle" [detailsGroupTypeColName]="detailsGroupTypeColName"
                        (onTableRowClick)="onTableRowClick($event)"
                        (onTableRowDetailsExportClick)="onTableRowDetailsExportClick($event)"
                        [reportTotalRow]="reportTotalRow">
                    </app-table>
                </div>
                <div *ngIf="selectedWindow == ReportsInventoryNames.inventoryValuationSummary">
                    <app-table [reportType]="'simpleTBSData'" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [reportDatas]="reportDatas" [cols]="cols"
                        [isActive]="isActive" [reportTotalRow]="reportTotalRow"
                        (onShowInActiveClick)="onShowInActiveClick($event)">
                    </app-table>
                </div>
            </div>
        </div>
    </div>
</div>

<p-toast position="top-right" [baseZIndex]="10000"></p-toast>
